import React from 'react';
import { createRoot } from 'react-dom/client'; // Updated import for React 19
import App from './App';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA6VmRQ4MABUqRC6ffDg5NUuJBlgrRnTMk",
  authDomain: "guppydz.firebaseapp.com",
  projectId: "guppydz",
  storageBucket: "guppydz.appspot.com",
  messagingSenderId: "581836025366",
  appId: "1:581836025366:web:ab7bc66f39b527eb1b8f37",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

// Export Firebase services
export { db, storage };

// Get the root element
const container = document.getElementById('root');

// Create a root and render the App component
const root = createRoot(container); // Create a root with the container
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
document.body.style.margin = '0';
document.body.style.padding = '0';